import { ref } from 'vue'

export default () => {
  const showProduct = ref(false)
  const showProductSku = ref(false)
  const showShopProduct = ref(false)
  const showShopProductSku = ref(false)

  type K = 'showProduct' | 'showProductSku' | 'showShopProduct' | 'showShopProductSku'
  const handleAllClose = () => {
    showProduct.value = false
    showProductSku.value = false
    showShopProduct.value = false
    showShopProductSku.value = false
  }
  const handleShow = (key: K) => {
    switch (key) {
      case 'showProduct':
        handleShowProduct()
        break
      case 'showProductSku':
        handleShowProductSku()
        break
      case 'showShopProduct':
        handleShowShopProduct()
        break
      case 'showShopProductSku':
        handleShowShopProductSku()
        break
    }
  }

  const handleShowProduct = () => {
    showProduct.value = true
    showProductSku.value = false
  }

  const handleShowProductSku = () => {
    showProduct.value = false
    showProductSku.value = true
  }

  const handleShowShopProduct = () => {
    showShopProduct.value = true
    showShopProductSku.value = false
  }

  const handleShowShopProductSku = () => {
    showShopProduct.value = false
    showShopProductSku.value = true
  }

  return {
    showProduct,
    showProductSku,
    showShopProduct,
    showShopProductSku,
    handleShow,
    handleAllClose
  }
}
